import { Weekday, WellnessHourSlot as HourSlot } from '../types/commons';

export const CHILDCARE_APPOINTMENT_STEP = 15; // minutes
export const WELLNESS_APPOINTMENT_STEP = 30; // minutes
export const CLEANING_APPOINTMENT_STEP = 15; // minutes
export const EARLY_SURCHARGE_END_TIME = '08:00';
export const LATE_SURCHARGE_START_TIME = '20:00';

export const RECURRING_CLEANING_HIGHLIGHTED_SLOTS: Record<Weekday, HourSlot[]> = {
  // sunday
  0: [],
  // monday
  1: ['10:30', '11:00', '11:30', '15:00', '15:30', '18:00', '18:30'],
  // tuesday
  2: ['12:00', '12:30', '14:00', '14:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30'],
  // wednesday
  3: ['11:00', '11:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00', '18:30'],
  // thursday
  4: ['12:00', '12:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30'],
  // friday
  5: ['15:00', '15:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30'],
  // saturday
  6: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30'],
};
